{"version":"1.0.0","gitHash":"cc8065fa","environment":"sandbox"}